import { Map, List } from "immutable";

import {
  USER_PROFILES_PARTNERSHIP_LIST_REQUEST,
  USER_PROFILES_PARTNERSHIP_LIST_SUCCESS,
  USER_PROFILES_PARTNERSHIP_LIST_FAILURE,
  USER_PROFILES_PARTNERSHIP_READ_REQUEST,
  USER_PROFILES_PARTNERSHIP_READ_SUCCESS,
  USER_PROFILES_PARTNERSHIP_READ_FAILURE,
  USER_PROFILES_PARTNERSHIP_UPDATE_REQUEST,
  USER_PROFILES_PARTNERSHIP_UPDATE_SUCCESS,
  USER_PROFILES_PARTNERSHIP_UPDATE_FAILURE,
  USER_PROFILES_PARTNERSHIP_CREATE_REQUEST,
  USER_PROFILES_PARTNERSHIP_CREATE_SUCCESS,
  USER_PROFILES_PARTNERSHIP_CREATE_FAILURE,
  USER_PROFILES_PARTNERSHIP_DELETE_REQUEST,
  USER_PROFILES_PARTNERSHIP_DELETE_SUCCESS,
  USER_PROFILES_PARTNERSHIP_DELETE_FAILURE,
  USER_PROFILES_PARTNERSHIP_FORM_DESTROY,
  USER_PROFILES_PARTNERSHIP_CSV_DOWNLOAD_REQUEST,
  USER_PROFILES_PARTNERSHIP_CSV_DOWNLOAD_SUCCESS,
  USER_PROFILES_PARTNERSHIP_CSV_DOWNLOAD_FAILURE,
} from "./actions";
import Logger from "../../../lib/Logger";

export default function userProfilesPartnerships(
  state = Map({
    isLoading: false,
    isCSVDownloading: false,
    pages: {},
  }),
  action
) {
  Logger.log(
    "debug",
    `[userProfilesPartnerships.reducers] userProfilesPartnerships(%j, %j)`,
    state,
    action
  );

  switch (action.type) {
    case USER_PROFILES_PARTNERSHIP_LIST_REQUEST:
      return state.mergeDeep({
        isLoading: true,
      });

    case USER_PROFILES_PARTNERSHIP_LIST_SUCCESS:
      return state
        .mergeDeep({
          isLoading: false,
          pages: {
            [action.order]: {
              [action.limit]: {
                [action.page]: null,
              },
            },
          },
          total: action.total,
          lastUpdated: action.receivedAt,
        })
        .setIn(
          ["pages", action.order, action.limit, action.page],
          List(action.result)
        );

    case USER_PROFILES_PARTNERSHIP_LIST_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });

    case USER_PROFILES_PARTNERSHIP_READ_REQUEST:
      return state.mergeDeep({
        isLoading: true,
      });

    case USER_PROFILES_PARTNERSHIP_READ_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        lastUpdated: action.receivedAt,
      });

    case USER_PROFILES_PARTNERSHIP_READ_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });

    case USER_PROFILES_PARTNERSHIP_UPDATE_REQUEST:
      return state.mergeDeep({
        isLoading: true,
        form: {
          isSubmitting: true,
          success: null,
          errors: null,
        },
      });

    case USER_PROFILES_PARTNERSHIP_UPDATE_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        form: {
          isSubmitting: false,
          success: true,
          errors: null,
        },
        lastUpdated: action.receivedAt,
      });

    case USER_PROFILES_PARTNERSHIP_UPDATE_FAILURE:
      return state
        .mergeDeep({
          isLoading: false,
          form: {
            isSubmitting: false,
            success: false,
            errors: null,
          },
        })
        .setIn(["form", "errors"], action.error);

    case USER_PROFILES_PARTNERSHIP_CREATE_REQUEST:
      return state.mergeDeep({
        isLoading: true,
        form: {
          isSubmitting: true,
          success: null,
          errors: null,
        },
      });

    case USER_PROFILES_PARTNERSHIP_CREATE_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        form: {
          isSubmitting: false,
          success: true,
          created_id: action.id,
          errors: null,
        },
        lastUpdated: action.receivedAt,
      });

    case USER_PROFILES_PARTNERSHIP_CREATE_FAILURE:
      return state
        .mergeDeep({
          isLoading: false,
          form: {
            isSubmitting: false,
            success: false,
            errors: null,
          },
        })
        .setIn(["form", "errors"], action.error);

    case USER_PROFILES_PARTNERSHIP_DELETE_REQUEST:
      return state.mergeDeep({
        isLoading: true,
      });

    case USER_PROFILES_PARTNERSHIP_DELETE_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        lastUpdated: action.receivedAt,
      });

    case USER_PROFILES_PARTNERSHIP_DELETE_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });

    case USER_PROFILES_PARTNERSHIP_FORM_DESTROY:
      return state
        .mergeDeep({
          form: null,
        })
        .set("form", action.form);

    case USER_PROFILES_PARTNERSHIP_CSV_DOWNLOAD_REQUEST:
      return state.mergeDeep({
        isCSVDownloading: true,
      });

    case USER_PROFILES_PARTNERSHIP_CSV_DOWNLOAD_SUCCESS:
      return state.mergeDeep({
        isCSVDownloading: false,
      });

    case USER_PROFILES_PARTNERSHIP_CSV_DOWNLOAD_FAILURE:
      return state.mergeDeep({
        isCSVDownloading: false,
      });

    default:
      return state;
  }
}

Logger.log("silly", `userProfilesPartnerships.reducers loaded.`);
